function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#b_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#00E4BF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .442)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 0,
  y: 0.3,
  width: 47.3,
  height: 49.1
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0.3,
  width: 47.3,
  height: 49.1,
  id: "b_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  id: "a_1_",
  className: "st1",
  d: "M0,0.3h47.3v49.1H0V0.3z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M0,25.5l22,13.7v10.1L0,35.6V25.5L0,25.5z M25.4,0.3l22,13.7v10.1l-22-13.7V0.3z M25.4,13.9l22,13.7v10.1 L25.4,24C25.4,24,25.4,13.9,25.4,13.9z M41.7,47.6L25.4,37.5V27.4l22,13.7v3.3c0,2-1.6,3.7-3.7,3.7C43,48.1,42.3,47.9,41.7,47.6z  M5.5,1.4L22,11.6v10.1L0,8V4.5c0-2,1.6-3.6,3.6-3.6C4.2,0.9,4.9,1.1,5.5,1.4L5.5,1.4z M0,11.8l22,13.7v10.1L0,21.9 C0,21.9,0,11.8,0,11.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M66.5,14.5h3.1l8.6,14.9l2.6,4.9h0.1c-0.1-2.4-0.4-5.1-0.4-7.6V14.5h2.9v23.8h-3.1l-8.6-15l-2.6-4.9h-0.1 c0.2,2.4,0.4,4.9,0.4,7.4v12.4h-2.9C66.5,38.2,66.5,14.5,66.5,14.5z M87.4,45.4l0.6-2.4c0.4,0.1,0.9,0.3,1.3,0.3c2,0,3.3-1.6,4-3.8 l0.4-1.3l-7.1-17.6h3.1l3.6,9.7c0.6,1.6,1.2,3.3,1.7,5h0.1c0.5-1.6,1-3.4,1.5-5l3.2-9.7h2.9l-6.6,19.1c-1.2,3.5-3,6.1-6.6,6.1 C88.8,45.8,88.1,45.7,87.4,45.4 M105.7,34.7V14.5h3v20.4c0,0.9,0.4,1.3,0.8,1.3c0.2,0,0.3,0,0.7-0.1l0.4,2.2 c-0.4,0.2-0.9,0.3-1.7,0.3C106.7,38.7,105.7,37.2,105.7,34.7 M123.9,33.9V29c-5.9,0.7-7.9,2.2-7.9,4.4c0,2,1.4,2.8,3.1,2.8 C120.8,36.3,122.2,35.4,123.9,33.9 M113.1,33.7c0-3.8,3.3-5.8,10.8-6.6c0-2.2-0.7-4.4-3.6-4.4c-2,0-3.9,0.9-5.3,1.9l-1.2-2.1 c1.6-1.1,4.1-2.3,6.9-2.3c4.3,0,6.1,2.9,6.1,7.2v10.8h-2.5l-0.3-2.1h-0.1c-1.7,1.4-3.6,2.5-5.8,2.5 C115.3,38.7,113.1,36.8,113.1,33.7 M129.4,36.2l1.5-2c1.5,1.2,3.1,2.1,5.2,2.1c2.3,0,3.5-1.2,3.5-2.8c0-1.8-2.1-2.6-4-3.3 c-2.5-0.9-5.1-2.1-5.1-5.1c0-2.8,2.2-5,6.1-5c2.2,0,4.1,0.9,5.5,2l-1.4,1.9c-1.2-0.9-2.5-1.6-4-1.6c-2.2,0-3.2,1.2-3.2,2.5 c0,1.7,1.8,2.3,3.8,3c2.5,0.9,5.4,2,5.4,5.3c0,2.9-2.3,5.3-6.4,5.3C133.4,38.7,131,37.6,129.4,36.2"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 50",
    style: {
      enableBackground: "new 0 0 143 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.103703a9.svg";
export { ForwardRef as ReactComponent };